import ActionsMenuPresentation from 'components/ActionsMenu/ActionsMenuPresentation'

export default {
  Presentation: ActionsMenuPresentation,
}
